import React from 'react';
// Styles
import '../../sass/components/credits.scss';

const Credits = () => (
  <footer>
    <div>Credits</div>
    <span>Copyright Cinemeye Vision Studio {new Date().getFullYear()}</span>
  </footer>
);
export default Credits;
